import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import CountryLabel from "./CountryLabel";

import craneOverlay from '../../../static/images/overlays/overlay--crane.svg';
import flagOverlay from '../../../static/images/overlays/overlay--flag.svg';
import rocketOverlay from '../../../static/images/overlays/overlay--rocket.svg';
import smallOverlay from '../../../static/images/overlays/overlay--small.svg';

const OVERLAYS = {
    crane: craneOverlay,
    flag: flagOverlay,
    rocket: rocketOverlay,
    small: smallOverlay,
};


const OverlayImage = ({overlayName}) => (
    <img
        className={`overlay overlay--${overlayName}`}
        // eslint-disable-next-line global-require
        src={OVERLAYS[overlayName]}
        alt={overlayName}
    />
);

OverlayImage.propTypes = {
    overlayName: PropTypes.string.isRequired,
};

const Overlay = ({overlayName, redirectUrl}) => {
    if (redirectUrl) {
        return (
            <a href={redirectUrl} target="_blank" rel="noopener noreferrer">
                <OverlayImage overlayName={overlayName} />
            </a>
        );
    } else {
        return (
            <OverlayImage overlayName={overlayName} />
        );
    }
};

Overlay.propTypes = {
    ...OverlayImage.propTypes,
    redirectUrl: PropTypes.string,
};

Overlay.defaultProps = {
    redirectUrl: undefined,
};


const CountryOverlay = ({countryName, overlayName, redirectUrl, children}) => (
    <div
        className={classNames(
            'background',
            'country-overlay',
            `country-overlay--${countryName.toLowerCase()}`,
            `country-overlay--${overlayName}`,
        )}
    >
        {overlayName &&
        <Overlay overlayName={overlayName} redirectUrl={redirectUrl} />
        }
        <CountryLabel countryName={countryName} />
        {children}
    </div>
);

CountryOverlay.propTypes = {
    countryName: PropTypes.string.isRequired,
    overlayName: PropTypes.oneOf(['crane', 'flag', 'rocket', 'small']),
    redirectUrl: PropTypes.string,
    children: PropTypes.node,
};

CountryOverlay.defaultProps = {
    overlayName: undefined,
    redirectUrl: undefined,
    children: undefined,
};

export default CountryOverlay;



// WEBPACK FOOTER //
// ./src/components/CountryOverlay.js